
import { Component, Vue } from "vue-property-decorator";
import {
  DeleteTransactionsTabs,
  DeleteTransactionsPanelHeader,
  TransactionDeletionsFilterWrapper,
  TransactionDeletionsGrid,
} from "@/components";
import { iniTransactionDeletionFilter, ITransactionDeletionFilter } from "@/services";

@Component({
  name: "delete-transactions",
  components: {
    DeleteTransactionsTabs,
    DeleteTransactionsPanelHeader,
    TransactionDeletionsGrid,
    TransactionDeletionsFilterWrapper,
  },
})
export class DeleteTransactionsPage extends Vue {
  solutionHistoryFilter: ITransactionDeletionFilter = { ...iniTransactionDeletionFilter };

  onUploadClick(): void {
    // Placeholder: emit or route to upload modal when implemented
  }
}
export default DeleteTransactionsPage;
